import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { AsyncButtonComponent } from "./async-button/async-button.component";
import { ButtonIconComponent } from "./button-icon/button-icon.component";
import { ButtonComponent } from "./button/button.component";
import { DirectivesModule } from "src/app/modules/bootstrap/directives/directives.module";
import { ButtonToggleComponent } from "src/app/components/ui/button/button-toggle/button-toggle.component";
import { DxButtonModule, DxDropDownButtonModule } from "devextreme-angular";

@NgModule({
  imports: [
    CommonModule,
    DirectivesModule,
    DxButtonModule,
    DxDropDownButtonModule
  ],
  declarations: [
    AsyncButtonComponent,
    ButtonComponent,
    ButtonIconComponent,
    ButtonToggleComponent
  ],
  exports: [
    AsyncButtonComponent,
    ButtonComponent,
    ButtonIconComponent,
    ButtonToggleComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ButtonModule {}
